const countryCodeMapping = {
  '+1': 'US', // United States
  '+1-246': 'BB', // Barbados
  '+1-268': 'AI', // Anguilla
  '+1-345': 'KY', // Cayman Islands
  '+1-441': 'BM', // Bermuda
  '+1-473': 'GD', // Grenada
  '+1-649': 'TC', // Turks and Caicos Islands
  '+1-758': 'LC', // Saint Lucia
  '+1-767': 'DM', // Dominica
  '+1-784': 'VC', // Saint Vincent and the Grenadines
  '+1-868': 'TT', // Trinidad and Tobago
  '+1-876': 'JM', // Jamaica
  '+7': 'RU', // Russia
  '+7': 'KZ', // Kazakhstan
  '+20': 'EG', // Egypt
  '+212': 'MA', // Morocco
  '+213': 'DZ', // Algeria
  '+218': 'LY', // Libya
  '+220': 'GM', // Gambia
  '+221': 'SN', // Senegal
  '+222': 'MR', // Mauritania
  '+223': 'ML', // Mali
  '+224': 'GN', // Guinea
  '+225': 'CI', // Ivory Coast (Côte d'Ivoire)
  '+226': 'BF', // Burkina Faso
  '+227': 'NE', // Niger
  '+228': 'TG', // Togo
  '+229': 'BJ', // Benin
  '+230': 'MU', // Mauritius
  '+231': 'LR', // Liberia
  '+232': 'SL', // Sierra Leone
  '+233': 'GH', // Ghana
  '+234': 'NG', // Nigeria
  '+235': 'TD', // Chad
  '+236': 'CF', // Central African Republic
  '+237': 'CM', // Cameroon
  '+238': 'CV', // Cape Verde
  '+239': 'ST', // São Tomé and Príncipe
  '+240': 'GQ', // Equatorial Guinea
  '+242': 'CG', // Republic of the Congo
  '+243': 'CD', // Democratic Republic of the Congo
  '+244': 'AO', // Angola
  '+245': 'GW', // Guinea-Bissau
  '+246': 'IO', // British Indian Ocean Territory
  '+247': 'AC', // Ascension Island
  '+248': 'SC', // Seychelles
  '+249': 'SD', // Sudan
  '+250': 'RW', // Rwanda
  '+251': 'ET', // Ethiopia
  '+252': 'SO', // Somalia
  '+253': 'DJ', // Djibouti
  '+255': 'TZ', // Tanzania
  '+257': 'BI', // Burundi
  '+258': 'MZ', // Mozambique
  '+260': 'ZM', // Zambia
  '+263': 'ZW', // Zimbabwe
  '+264': 'NA', // Namibia
  '+265': 'MW', // Malawi
  '+266': 'LS', // Lesotho
  '+267': 'BW', // Botswana
  '+268': 'SZ', // Eswatini
  '+290': 'SH', // Saint Helena
  '+291': 'ER', // Eritrea
  '+297': 'AW', // Aruba
  '+298': 'FO', // Faroe Islands
  '+299': 'GL', // Greenland
  '+30': 'GR', // Greece
  '+31': 'NL', // Netherlands
  '+32': 'BE', // Belgium
  '+33': 'FR', // France
  '+34': 'ES', // Spain
  '+36': 'HU', // Hungary
  '+39': 'IT', // Italy
  '+40': 'RO', // Romania
  '+41': 'CH', // Switzerland
  '+420': 'CZ', // Czech Republic
  '+43': 'AT', // Austria
  '+44': 'GB', // United Kingdom
  '+45': 'DK', // Denmark
  '+46': 'SE', // Sweden
  '+47': 'NO', // Norway
  '+48': 'PL', // Poland
  '+49': 'DE', // Germany
  '+51': 'PE', // Peru
  '+52': 'MX', // Mexico
  '+53': 'CU', // Cuba
  '+54': 'AR', // Argentina
  '+55': 'BR', // Brazil
  '+56': 'CL', // Chile
  '+57': 'CO', // Colombia
  '+58': 'VE', // Venezuela
  '+59': 'GU', // Guam
  '+60': 'MY', // Malaysia
  '+61': 'AU', // Australia
  '+62': 'ID', // Indonesia
  '+63': 'PH', // Philippines
  '+64': 'NZ', // New Zealand
  '+65': 'SG', // Singapore
  '+66': 'TH', // Thailand
  '+81': 'JP', // Japan
  '+82': 'KR', // South Korea
  '+84': 'VN', // Vietnam
  '+86': 'CN', // China
  '+90': 'TR', // Turkey
  '+91': 'IN', // India
  '+92': 'PK', // Pakistan
  '+93': 'AF', // Afghanistan
  '+94': 'LK', // Sri Lanka
  '+95': 'MM', // Myanmar
  '+98': 'IR', // Iran
  '+211': 'SS', // South Sudan
  '+241': 'GA', // Gabon
  '+254': 'KE', // Kenya
  '+256': 'UG', // Uganda
  '+261': 'MG', // Madagascar
  '+262': 'RE', // Réunion
  '+269': 'KM', // Comoros
  '+1': 'CA',   //Canada
  '+351':"PT", //Portugal
  '+353':'IE', //Ireland
  '+972':'IL', //Israel
  '+27':'ZA', //South Africa
  '+682':'CK', //Cook Islands
  '+681':'WF', //Wallis and Futuna
  '+687':'NC', //New Caledonia
  '+689':'PF', //French Polynesia

};
export default countryCodeMapping;